import { usePathname } from "next/navigation";
import { useMemo } from "react";

import { MODULES } from "@/data/constants/layout";
import { ModuleName } from "@/data/constants/layout";

import { useLang } from "./use-lang";

export const usePath = () => {
  const { lang } = useLang();
  const pathname = usePathname();
  const paths = useMemo(() => pathname.split("/"), [pathname]);
  const pathSet = useMemo(() => new Set(paths), [paths]);

  const isHomePage = pathname === `/${lang}`;

  // 只要有一個 path 包含 stockmining
  const isStockMiningPage = useMemo(
    () => paths.some((path) => path.includes("stockmining")),
    [paths]
  );

  // 找到第一個符合的 moduleName
  const moduleName = useMemo<ModuleName>(() => {
    return MODULES.findLast((m) => pathSet.has(m)) ?? "";
  }, [pathSet]);

  // 產生 boolean 屬性
  const flags = useMemo(
    () => ({
      isMyPage: pathSet.has("my"),
      isAnalysisPage: pathSet.has("analysis"),
      isScreenerPage: pathSet.has("screener"),
      is13FPage: pathSet.has("13f"),
      isNotificationPage: pathSet.has("notification"),
      isNotificationLinePage:
        pathSet.has("notification") && pathSet.has("line"),
      isStripePage: pathSet.has("stripe"),
      isAuthPage: pathSet.has("auth"),
      isMarketFearGreedPage: pathSet.has("fear-and-greed"),
      isMarketEarlyWarningPage: pathSet.has("market-early-warning-indicator"),
      isTradingViewAdvancedChartPage: pathSet.has("tradingview-advanced-chart"),
    }),
    [pathSet]
  );

  const lastRoute = useMemo(() => paths[paths.length - 1], [paths]);

  return {
    ...flags,
    isHomePage,
    isStockMiningPage,
    moduleName,
    lastRoute,
  };
};
